function showContinent(continent) {
	let countries = document.getElementsByClassName('country');
	let filters = document.getElementsByClassName('country-filter');

	for (let i = 0; i < countries.length; i++) {
		countries[i].classList.remove('d-none');
	}

	for (let i = 0; i < filters.length; i++) {
		filters[i].classList.remove('active');
	}

	if (continent === 'all') {
		document.querySelector(`.country-filter[data-filter-countries='all']`).classList.add('active');
	} else {
		for (let i = 0; i < countries.length; i++) {
			let continents = JSON.parse(countries[i].dataset.continent);

			if (!Array.isArray(continents)) {
				continents = [continents];
			}

			if (continents.indexOf(continent) == -1) {
				countries[i].classList.add('d-none');
			}
		}
		document.querySelector(`.country-filter[data-filter-countries='${continent}']`).classList.add('active');
	}

	return false;
}

document.addEventListener('DOMContentLoaded', function () {
	document.addEventListener('click', (e) => {
		const element = e.target.closest('.js_show_continent');
		if (!element) return;

		showContinent(element.dataset.filterCountries);
	});
});
